import * as classnames from 'classnames'
import * as React from 'react'

import * as styles from './textLink.module.css'

interface IProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {}

const TextLink = ({ className = '', children, ...restProps }: IProps) => (
  <a className={classnames(styles.textLink, className)} {...restProps}>
    {children}
  </a>
)

export default TextLink
